import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ScheduledEvent } from '../../../../../../../../models/scheduled-event';
import { ScheduledEventService } from '../../../../../../../../services/scheduled-event/scheduled-event.service';
import { dateStringFromISO8601, getBrowserTimeZone, getTimeZoneDisplayName, timeStringFromISO8601 } from '../../../../../../../../utils';
import { getScheduledEventRouterPath } from '../../../../../../../../utils-models';
import { Router } from '@angular/router';


@Component({
  selector: 'app-calendar-event-modal',
  templateUrl: './calendar-event-modal.component.html',
  styleUrls: ['./calendar-event-modal.component.css']
})
export class CalendarEventModalComponent implements OnInit {
  @Input() eventPartId: number;

  public scheduledEvent: ScheduledEvent;

  public loading = false;

  public serverError: number = null;

  public timeStringFromISO8601 = timeStringFromISO8601;
  public dateStringFromISO8601 = dateStringFromISO8601;
  public getScheduledEventRouterPath = getScheduledEventRouterPath;
  public getTimeZoneDisplayName = getTimeZoneDisplayName;

  constructor(
    public activeModal: NgbActiveModal,
    private scheduledEventService: ScheduledEventService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadScheduledEvent();
  }

  private loadScheduledEvent() {
    this.loading = true;

    this.scheduledEventService
      .getScheduledEvent(this.eventPartId)
      .then(scheduledEvent => {
        this.scheduledEvent = scheduledEvent;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loading = false; });
  }
}
